// ponytail: hook único por data-attr, sin config. Upgrade path: parametrizar por section settings si el merchant lo pide.
document.addEventListener('DOMContentLoaded', () => {
  if (!window.gsap || !window.ScrollTrigger) return;
  gsap.registerPlugin(ScrollTrigger);

  const targets = document.querySelectorAll('[data-wetheme-section-type="video--video"] .homepage-hero-content--video');
  targets.forEach((el) => {
    gsap.fromTo(
      el,
      { scale: 0.7, borderRadius: '48px', opacity: 0.6 },
      {
        scale: 1,
        borderRadius: '0px',
        opacity: 1,
        ease: 'none',
        scrollTrigger: { trigger: el, start: 'top 85%', end: 'center 55%', scrub: 1 },
      }
    );
  });
});
